if (!customElements.get('korvia-reviews')) {
  customElements.define('korvia-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animate !== 'true' || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('krv__enter');
          this.observer.unobserve(entry.target);
        });
      }, { threshold: 0.08 });
      this.querySelectorAll('.krv__card').forEach(card => this.observer.observe(card));
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
}
